import { render, staticRenderFns } from "./messageSwitch.vue?vue&type=template&id=227bc5ee&scoped=true"
import script from "./messageSwitch.vue?vue&type=script&lang=js"
export * from "./messageSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bc5ee",
  null
  
)

export default component.exports